import { Injectable } from '@angular/core';
import { SpaContext } from '../../../../Classes/spacontext';
import { WebContentButtonApiModel, OpenUrlWith } from '../Models/WebContentButtonApiModel';
import { SpaEventService } from '../../../spaEvents.service';
import { WebContentButtonTranslationApiModel } from '../Models/WebContentButtonTranslationApiModel';
import { Router } from '@angular/router';
import { OpenTargetWith } from 'Public_old/src/app/Components/Authentication/signin.component';
import { AuthContextService } from '../../../authContext.service';
import { ComponentIdentityButtonIcon } from '../../../flexible_patient_buttons.service/component_identity_button_icon';
import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '@public/src/shared_resolution';

export interface EmbeddedWebContent {
	baseUrl: string;
	ewUrl: string;
}

@Injectable()
export class WebContentButtonsService {
	readonly baseUri = '/api/Client/v2/units';
	public selectedEmbeddedContent: EmbeddedWebContent;

	constructor(
		private spaEventService: SpaEventService,
		public spaContext: SpaContext,
		private router: Router,
		private authContextService: AuthContextService,
	) {}

	public goToCustomButtonUrl(button: ComponentIdentityButtonIcon) {
		switch (button.openUrlWith) {
			case OpenUrlWith.IFrame: {
				this.selectedEmbeddedContent = {
					baseUrl: window.location.origin + this.spaContext.baseHref,
					ewUrl: button.url,
				};

				const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
				let ewRoute = `${locationSelectorService.location.route}/ew?url=${button.url}`;
				if (!ewRoute.startsWith('/')) {
					ewRoute = `/${ewRoute}`;
				}

				if (button.requiresAuthentication && !this.authContextService.isSignedIn()) {
					this.spaEventService.onSignInRequired.emit({
						target: ewRoute,
						openTargetWith: OpenTargetWith.AngularNavigation,
					});

					return;
				}

				this.router.navigate([`${locationSelectorService.location.route}/ew`], {
					queryParams: {
						url: button.url,
					},
				});
				break;
			}
			case OpenUrlWith.NewTab: {
				if (button.requiresAuthentication && !this.authContextService.isSignedIn()) {
					this.spaEventService.onSignInRequired.emit({
						target: button.url,
						openTargetWith: OpenTargetWith.NewTab,
					});

					return;
				}
				window.open(button.url);
				break;
			}
			case OpenUrlWith.SameTab: {
				if (button.requiresAuthentication && !this.authContextService.isSignedIn()) {
					this.spaEventService.onSignInRequired.emit({ target: button.url, openTargetWith: OpenTargetWith.NativeNavigation });

					return;
				}
				location.href = button.url;
				break;
			}
		}
	}

	public getButtonTranslation(button: WebContentButtonApiModel): WebContentButtonTranslationApiModel {
		return button.Translations.find((language) => language.LanguageCode === this.spaContext.languageCode);
	}
}
